export default '__SKU_CLIENT_CONTEXT__';
